import { Typography } from '@mui/material'
import React from 'react'
import './profile.css'
import CustomTimeline, { CustomTimelineSeparator } from '../Timeline/Timeline'
import ResumeData from '../../utils/ResumeData'
import PersonIcon from '@mui/icons-material/Person';
import { TimelineContent, TimelineItem } from '@mui/lab'
import CustomButton from '../Button/Button'
import GetAppIcon from '@mui/icons-material/GetApp';

const CustomTimelineItem = ({title,text,link})=>{
    return(
        <TimelineItem>
            <CustomTimelineSeparator/>
            <TimelineContent className='timeline-content'>
                {
                    link? (<Typography className='timeline-text'><span>{title}:</span> <a href={link} target="_blank">{text}</a></Typography>):(
                        <Typography className='timeline-text'><span>{title}:</span> {text}</Typography>
                    )
                }
            </TimelineContent>
        </TimelineItem>
    )
}

const Profile = () => {
  function handleDownloadClick() {
    const link = document.createElement('a');
    link.href = '/assets/documents/ab.pdf';
    link.download = 'ab.pdf';
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  }
  return (
    <div className='profile container_shadow'>
      <div className='profile_name'>
        <Typography className='name'>{ResumeData.name}</Typography>
        <Typography className='profession'>{ResumeData.profession}</Typography>
      </div>
      <figure className='profile_image'>
        <img src={require("../../assets/images/profile.jpg")} alt="" />
      </figure>
      <div className='profile_info'>
          <CustomTimeline icon={<PersonIcon/>}>
            <CustomTimelineItem title="Name" text={ResumeData.name}/>
            <CustomTimelineItem title="Profession" text={ResumeData.profession}/>
            <CustomTimelineItem title="Email" text={ResumeData.email}/>
            {
                Object.keys(ResumeData.socials).map(key=>
                    ( <CustomTimelineItem title={key} text={ResumeData.socials[key].text}
                        link={ResumeData.socials[key].link}/>
                    ))
            }
            </CustomTimeline>
          <div className='button'>
          <CustomButton text={'Download Cv'} icon={<GetAppIcon/>} onPress={handleDownloadClick}/>
          </div>
      </div>
    </div>
  )
}

export default Profile